const E = "checkbox", e = {
  INDETERMINATE: "indeterminate",
  VALID: "valid",
  ERROR: "error",
  DEFAULT: "default"
};
export {
  E as CHECKBOX_BASE_CLASS,
  e as CHECKBOX_STATES
};
